<div class="row">
    <div class="head-component m-b-25">
        <div class="col-10 m-0 p-l-20 br-0 head-component for-fixed-component card">
            <div class="col-9 p-l-20 pl-0 pr-0 card-body d-flex align-items-center">
                <div>
                    <h5 class="m-0 head-main-component" id="page_title">
                        Question Bank
                    </h5>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row p-l-25 p-r-15">
  <div class="col-9 pl-0">
    <ol class="admin-nav-questions bc-colored base-shadow-list b-0 m-b-10 bg-info">
      <li class="admin-nav-title">
        <span>{{ categoryName }}</span>
      </li>
      <li class="float-right btn btn-white-sm btn-circle shadowed-button m-r-20" id="add-new-question" (click)="addQuestion()">
        <i class="ti-plus text-info"></i>
      </li>
      <li class="float-right col-3 m-t-10 m-r-10 ">
        <div class="form-inline active-search form-sm">
          <input class="form-control form-control-sm mr-1 col-10" id="questions_search"
          [(ngModel)] = "searchText" 
          type="text" placeholder="Search" aria-label="Search">
          <i class="fa fa-search"  aria-hidden="true"></i>
        </div>
      </li>
    </ol>
    <div class="row">
      <div class="col-12" *ngIf="isAddQuestionForm">
        <div class="card m-b-15 base-shadow-list b-0">
          <div class="card-body">
            <app-question-forms-builder isAddForm = "true" 
            [selectedCategoryId] = "selectedCategoryId"
            (onSaveAddEditForm)="closeOnSave($event)" 
            (onCancelForm)="hideForm()">
          </app-question-forms-builder>
          </div>
        </div>
      </div>
      <div *ngFor="let question of questions  |  filter : ['name'] : searchText" class="col-12">
              <app-question-forms-selector 
              (onDeleteQuestion)="deleteQuestion($event)" 
              (onCloneQuestion)="cloneQuestion($event)"
              [selectedCategoryId] = "selectedCategoryId" [question]="question"></app-question-forms-selector>
        </div>
    </div>
  </div>
  <div class="col-3 p-l-10 pr-0">
    <app-categories-list (categoryChange)="getCategoryQuestions($event)"></app-categories-list>
  </div>
</div>